import PropTypes from "prop-types"
import { useContext, useEffect, useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { isValidEmail } from "../utils/general";
import { AppState } from "../lib/context/AppProvider";
import { toast } from "react-toastify";

const SignupModal = ({showModal, isReset, setShowModal}) => {
    const [email, setEmail] = useState(null);
    const [loading, setLoading] = useState(false);

    const {postData} = useContext(AppState);

    useEffect(() => {
        setEmail(null);
    }, [isReset]);

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleConfirm = async (e) => {
        e.preventDefault();

        if (!isValidEmail(email)) return;

        setLoading(true);

        const path = isReset ? "account/reset/verify" : "signup/verify";
        const response = await postData(path, [], "POST", {
            email: email
        }, true);

        setLoading(false);

        if (response?.isError) {
            const msg = response.error?.message;
            if (msg.includes("verification code was already sent")) {
                toast.warn(msg);
            } else {
                toast.error(msg);
                return;
            }
        }

        toast.success(`A ${isReset ? "password reset" : "sign up"} link was sent to ${email}. Check your email to continue.`);
        setShowModal(false);
    };

    return (
        <Modal show={showModal} onHide={handleCloseModal}>
            <Modal.Header closeButton data-bs-theme="dark" className="bg-dark text-white">
                <Modal.Title>{isReset ? "Reset Password" : "Register New Account"}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-dark text-white">
                <Form onSubmit={handleConfirm} data-testid="update-providers-form">
                    <Form.Group controlId="formEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter your email address"
                            required
                            value={email ?? ""}
                            onChange={(e) => setEmail(e.target.value.trim())}
                            className="bg-dark text-white"
                            isInvalid={email && !isValidEmail(email)}
                            name="username"
                            autoFocus
                        />
                        <Form.Control.Feedback type="invalid">
                            Invalid email address
                        </Form.Control.Feedback>
                    </Form.Group>
                    <div className="mt-3 d-flex justify-content-end">
                        <Button variant="primary" type="submit" disabled={!isValidEmail(email) || loading}>
                            {isReset ? "Send Reset Link" : "Send Sign Up Link"}{loading && (
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    aria-hidden="true"
                                    className="ms-2"
                                />
                            )}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

SignupModal.propTypes = {
  setShowModal: PropTypes.func,
  showModal: PropTypes.bool,
  isReset: PropTypes.bool
}

export default SignupModal;
